import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AiChatState, aiChatFeatureKey } from './ai-chat.state';

export const selectAiChatFeature =
  createFeatureSelector<AiChatState>(aiChatFeatureKey);

export const selectCurrentConversationId = createSelector(
  selectAiChatFeature,
  (state: AiChatState) => state.currentConversationId
);

export const selectMessages = createSelector(
  selectAiChatFeature,
  (state: AiChatState) => state.messages
);

export const selectConversations = createSelector(
  selectAiChatFeature,
  (state: AiChatState) => state.conversations
);

export const selectIsLoading = createSelector(
  selectAiChatFeature,
  (state: AiChatState) => state.isLoading
);

export const selectError = createSelector(
  selectAiChatFeature,
  (state: AiChatState) => state.error
);

export const selectIsStreaming = createSelector(
  selectAiChatFeature,
  (state: AiChatState) => state.isStreaming
);

export const selectStreamingResponse = createSelector(
  selectAiChatFeature,
  (state: AiChatState) => state.streamingResponse
);

export const selectConversationsLoading = createSelector(
  selectAiChatFeature,
  (state: AiChatState) => state.conversationsLoading
);

export const selectConversationsOffset = createSelector(
  selectAiChatFeature,
  (state: AiChatState) => state.conversationsOffset
);

export const selectConversationsCount = createSelector(
  selectAiChatFeature,
  (state: AiChatState) => state.conversationsCount
);

export const selectConversationsLimit = createSelector(
  selectAiChatFeature,
  (state: AiChatState) => state.conversationsLimit
);

export const selectCurrentConversation = createSelector(
  selectAiChatFeature,
  selectCurrentConversationId,
  (state: AiChatState, conversationId: number | null) => {
    if (!conversationId) {
      return null;
    }
    return state.conversations.find((conv) => conv.id === conversationId);
  }
);

export const selectRateLimit = createSelector(
  selectAiChatFeature,
  (state: AiChatState) => state.rateLimit
);

export const selectIsOpenChatVia = createSelector(
  selectAiChatFeature,
  (state: AiChatState) => state.isOpenChatVia
);
